import Styled from 'styled-components';

const TemplateEditView = Styled.div`
    .taskconatiner{
        background-color:${({ theme }) => theme["tableViewCard"]};;
    }
    .select-template-options{
        border-radius: 5px;
        padding: 0px 10px;
        /* width :210px; */
        height: 30px;
    }
`
export default TemplateEditView;